import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./css/equipments.css";
import SewerIMage1 from "../assets/images/NewImage1.jpeg";
import SewerIMage2 from "../assets/images/NewImage2.jpeg";
import Manhole1 from "../assets/images/NewImage3.jpeg";
import SewerIMage3 from "../assets/images/NewImage4.jpeg";
// import Manhole2 from "../assets/images/manholeInspection2.jpg";
// import Manhole3 from "../assets/images/manholeInspection3.jpg";
// import DrainageKeepup from "../assets/images/DrainageKeepup.jpg";
// import DrainageKeepup2 from "../assets/images/DrainageKeepup2.jpg";
// import DrainageKeepup3 from "../assets/images/DrainageKeepup3.jpg";
// import DrainageKeepup4 from "../assets/images/DrainageKeepup4.jpg";

const Equipments = () => {
  const [activeFilter, setActiveFilter] = useState("All");
  const [isAnimating, setIsAnimating] = useState(false);

  const equipmentsItems = [
    {
      id: 1,
      categories: ["Super Sucker machine"],
      image: SewerIMage1,
      description:
        "The Super Sucker Machine is an innovative aquatic vacuum system designed to remove invasive plants, algae, and debris from water bodies. Operating like a giant underwater suction device, it efficiently clears overgrown vegetation without disturbing fish or other marine life, making it an eco-friendly solution for ecosystem restoration.",
    },
    {
      id: 3,
      categories: ["Vacuum Truck"],
      image: SewerIMage2,
      description:
        "A vacuum truck, also known as a suction truck or vacuum tanker, is a heavy-duty vehicle equipped with a powerful vacuum pump and storage tank, designed to safely collect and transport liquids, sludge, and solid waste. ",
    },
    {
      id: 4,
      categories: ["Sewer Jetting Machine"],
      image: Manhole1,
      description:
        "A sewer jetting machine is a high-pressure cleaning system designed to clear blockages and debris from pipes, drains, and sewer lines using pressurized water. Equipped with a powerful pump and specialized nozzles, it blasts away grease, tree roots, sludge, and other obstructions, restoring proper flow and preventing pipe damage.",
    },
    {
      id: 4,
      categories: ["Sewer Jetting Machine"],
      image: SewerIMage3,
      description:
        "A sewer jetting machine is a high-pressure cleaning system designed to clear blockages and debris from pipes, drains, and sewer lines using pressurized water. Equipped with a powerful pump and specialized nozzles, it blasts away grease, tree roots, sludge, and other obstructions, restoring proper flow and preventing pipe damage.",
    },
  ];

  const categories = [
    "All",
    "Sewer Jetting Machine",
    "Super Sucker machine",
    "Vacuum Truck",
  ];

  const getFilteredItems = (filter) => {
    return filter === "All"
      ? equipmentsItems
      : equipmentsItems.filter((item) => item.categories.includes(filter));
  };

  const handleFilterChange = (newFilter) => {
    if (newFilter === activeFilter || isAnimating) return;

    setIsAnimating(true);
    setActiveFilter(newFilter);

    // Set a timeout to reset the animation state after the transition completes
    setTimeout(() => {
      setIsAnimating(false);
    }, 500); // Match this duration with your animation duration
  };

  const filteredItems = getFilteredItems(activeFilter);

  return (
    <div id="equipments" className="equipments-container">
      <div className="equipments-header">
        <h1>EQUIPMENTS</h1>
        <div className="divider"></div>
      </div>
      {/* Navigation Tabs */}
      {/* <div className="equipments-nav-container">
        <div className="equipments-nav-tabs">
          {categories.map((category, index) => (
            <React.Fragment key={category}>
              <button
                onClick={() => handleFilterChange(category)}
                disabled={isAnimating}
                className={`equipments-nav-button ${
                  activeFilter === category ? "equipments-nav-button-active" : ""
                } ${isAnimating ? "equipments-nav-button-disabled" : ""}`}
              >
                {category}
              </button>
              {index < categories.length - 1 && (
                <div className="equipments-slash">/</div>
              )}
            </React.Fragment>
          ))}
        </div>
      </div> */}

      {/* equipments Grid */}
      <div className="equipments-grid-container">
        <motion.div className="equipments-grid" layout>
          <AnimatePresence>
            {filteredItems.map((item) => (
              <motion.div
                key={item.id}
                layout
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.8 }}
                transition={{ duration: 0.3, ease: "easeInOut" }}
                className="equipments-item group"
              >
                <div className="equipments-item-image-container">
                  <img
                    src={item.image}
                    alt={item.description}
                    className="equipments-item-image"
                  />
                </div>

                {/* Overlay */}
                <div className="equipments-item-overlay">
                  <div className="equipments-item-overlay-content">
                    <h3 className="equipments-item-description">
                      {item.categories.join(" • ")}
                    </h3>
                    <p className="equipments-item-categories">
                      {item.description}
                    </p>
                  </div>
                </div>

                {/* Category Badges */}
                {/* <div className="equipments-item-badges">
                  {item.categories.map((category, index) => (
                    <span
                      key={index}
                      className={`equipments-item-badge ${getCategoryClass(
                        category
                      )}`}
                    >
                      {category.length > 10
                        ? `${category.substring(0, 10)}...`
                        : category}
                    </span>
                  ))}
                </div> */}
              </motion.div>
            ))}
          </AnimatePresence>
        </motion.div>
      </div>
    </div>
  );
};

// Helper functions remain the same
// const getImageId = (category) => {
//   const imageMap = {
//     "Super Sucker machine": "1416879595882-3373a3480c25",
//     Repairing: "1581833971358-2c8b550f87b3",
//     "Sewer Jetting Machine": "1586023492125-27b2c045efd7",
//   };
//   return imageMap[category] || "1416879595882-3373a3480c25";
// };

export default Equipments;
